function $13e636c115f5b023$export$863e749b3f21e4ce(p, props) {
    const [tag, ...classes] = p.split(".");
    const c = document.createElement(tag);
    for (const n of classes)c.classList.add(n);
    for(const prop in props)c[prop] = props[prop];
    return c;
}
function $13e636c115f5b023$export$f9574b70e1d95d9d(parent, p, props) {
    const c = $13e636c115f5b023$export$863e749b3f21e4ce(p, props);
    parent.appendChild(c);
    return c;
}
function $13e636c115f5b023$export$157e4ea108f7048c(el, predicate) {
    while(el){
        if (predicate(el)) return el;
        el = el.parentElement;
    }
    return null;
}
function $13e636c115f5b023$export$2796c4ce44e61efa(el, name, condition) {
    if (condition) el.classList.add(name);
    else el.classList.remove(name);
}
function $13e636c115f5b023$export$6f093cfa640b7166(el, text) {
    el.appendChild(document.createTextNode(text));
}




class $1d06730851e9bddb$export$2e2bcd8739ae039 {
    constructor(cells){
        this.cells = cells;
        this.images = [];
        this.classes = [];
    }
    addImage(img) {
        this.images.push(img);
        for (const className of this.classes)img.classList.add(className);
    }
    get size() {
        return this.images.length;
    }
    setClass(...classes) {
        for (const img of this.images)for (const className of this.classes)img.classList.remove(className);
        this.classes = classes;
        for (const img of this.images)for (const className of this.classes)img.classList.add(className);
    }
    includesTile(tx, ty) {
        return this.cells.some((cell)=>cell.x == tx && cell.y == ty);
    }
    similarity(other) {
        let s = 0;
        for (const { x: x, y: y } of this.cells)if (other.includesTile(x, y)) ++s;
        return s;
    }
    mostSimilar(others) {
        let mss = 0, ms = null;
        for (const other of others){
            const s = this.similarity(other);
            if (s > mss) {
                mss = s;
                ms = other;
            }
        }
        return ms;
    }
    // true if:
    //  * every bead on this ribbon is the same colour, AND
    //  * every bead of that colour is on this ribbon
    isComplete(beads) {
        const coloursOnRibbon = new Set(), coloursOffRibbon = new Set();
        for (const { x: x, y: y, colour: colour } of beads)if (this.includesTile(x, y)) coloursOnRibbon.add(colour);
        else coloursOffRibbon.add(colour);
        if (coloursOnRibbon.size != 1) return {
            complete: false
        };
        const [colour] = coloursOnRibbon;
        return {
            complete: !coloursOffRibbon.has(colour),
            colour: colour
        };
    }
    highlightBy(x, y) {
        // this is horrible code but it works so just collapse this function in your ide and don't think about it
        if (x === undefined) {
            for (const img of this.images){
                img.classList.remove("highlight-off");
                img.classList.remove("highlight-on");
                img.classList.remove("highlight-close");
            }
            return;
        }
        if (!this.includesTile(x, y)) {
            for (const img of this.images){
                img.classList.add("highlight-off");
                img.classList.remove("highlight-on");
                img.classList.remove("highlight-close");
            }
            return;
        }
        for (const img of this.images){
            img.classList.remove("highlight-off");
            img.classList.add("highlight-on");
            img.classList.remove("highlight-close");
        }
        // TODO: get this array in order so taht highlighting words???
        const start = $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x, y));
        const doneImages = new Set([
            start
        ]);
        const move = (img, direction)=>{
            let { x: x, y: y } = img.parentElement.parentElement.dataset;
            x = parseInt(x, 10);
            y = parseInt(y, 10);
            // 1 2 3
            // 4 * 6
            // 7 8 9
            switch(direction){
                case "1":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x - 1, y - 1)),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x - 1, y), "d1x"),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x, y - 1), "d1y")
                    ];
                case "2":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x, y - 1))
                    ];
                case "3":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x + 1, y - 1)),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x + 1, y), "d3x"),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x, y - 1), "d3y")
                    ];
                case "4":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x - 1, y))
                    ];
                case "6":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x + 1, y))
                    ];
                case "7":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x - 1, y + 1)),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x - 1, y), "d3y"),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x, y + 1), "d3x")
                    ];
                case "8":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x, y + 1))
                    ];
                case "9":
                    return [
                        $1d06730851e9bddb$var$mainImageIn($1d06730851e9bddb$var$cellAt(x + 1, y + 1)),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x + 1, y), "d1y"),
                        $1d06730851e9bddb$var$diagCornerIn($1d06730851e9bddb$var$cellAt(x, y + 1), "d1x")
                    ];
                default:
                    throw new Error("unexpected direction");
            }
        };
        start.classList.add("highlight-close");
        const startDirections = [
            ...start.classList
        ].find((x)=>x.startsWith("img-")).substring(4).split("-");
        for (const sd of startDirections){
            let [c, ...corners] = move(start, sd);
            for (const corner of corners)corner.classList.add("highlight-close");
            for(let i = 0; i < 10; ++i){
                c.classList.add("highlight-close");
                doneImages.add(c);
                const directions = [
                    ...c.classList
                ].find((x)=>x.startsWith("img-")).substring(4).split("-");
                for (const d of directions){
                    const [next, ...corners] = move(c, d);
                    if (doneImages.has(next)) continue;
                    for (const corner of corners)corner.classList.add("highlight-close");
                    c = next;
                    break;
                }
            }
        }
    }
}
function $1d06730851e9bddb$var$cellAt(x, y) {
    // TODO: this is hacky but ok for now
    const c = document.querySelector(`[data-x="${x}"][data-y="${y}"] .ribbon-images`);
    if (!c) throw new Error("Missing cell");
    return c;
}
function $1d06730851e9bddb$var$diagCornerIn(cell, className) {
    const c = cell.querySelector(`div.img-${className}`);
    if (!c) throw new Error("Missing corner");
    return c;
}
function $1d06730851e9bddb$var$mainImageIn(cell) {
    const i = cell.querySelector("div:not(.img-d1x):not(.img-d1y):not(.img-d3x):not(.img-d3y)");
    if (!i) throw new Error("Missing image");
    return i;
}


function $ccc8a8194b547ffa$export$2e2bcd8739ae039(w, h) {
    const cells = [];
    for(let y = 0; y < h * 2; ++y){
        const row = [];
        cells.push(row);
        for(let x = 0; x < w * 2; ++x)row.push({
            x: x,
            y: y,
            xParity: !!(x & 1),
            yParity: !!(y & 1),
            xyParity: (x & 1) == (y & 1),
            vWall: false,
            hWall: false
        });
    }
    return cells;
}



function $b45f222a6e87d68f$export$2e2bcd8739ae039(w, h, wallCount) {
    const cells = (0, $ccc8a8194b547ffa$export$2e2bcd8739ae039)(w, h);
    const usedWalls = new Set();
    while(usedWalls.size < wallCount){
        const x = Math.round(Math.random() * w * 2 - 2), y = Math.round(Math.random() * h * 2 - 2);
        if (x < 1 || y < 1) continue;
        if ((x & 1) == (y & 1)) continue;
        const k = `${x}-${y}`;
        if (usedWalls.has(k)) continue;
        usedWalls.add(k);
        if (usedWalls.has(`${x - 1}-${y - 1}`) || usedWalls.has(`${x + 1}-${y - 1}`) || usedWalls.has(`${x - 1}-${y + 1}`) || usedWalls.has(`${x + 1}-${y + 1}`)) continue;
        if (Math.random() < 0.5) {
            cells[y][x + 1].vWall = true;
            cells[y + 1][x + 1].vWall = true;
        } else {
            cells[y + 1][x].hWall = true;
            cells[y + 1][x + 1].hWall = true;
        }
    // for (const row of cells) {
    // 	console.log(" " + row.map(r => (r.hWall ? "—" : " ") + (r.y > 0 && r.x < row.length - 1 && r.xyParity ? "•" : " ")).join(""));
    // 	console.log(row.map(r => (r.vWall ? "|" : " ") + (r.ribbon?.toString(36) ?? "-")).join(""));
    // }
    }
    return {
        cells: cells,
        ribbons: $b45f222a6e87d68f$export$61a292a1761d5bd5(cells)
    };
}
function $b45f222a6e87d68f$export$61a292a1761d5bd5(cells) {
    const unusedCells = new Set(cells.flat());
    const ribbons = [];
    while(unusedCells.size){
        // const ribbonLabel = String.fromCharCode(ribbon++ + +65);
        let current = [
            ...unusedCells
        ][0];
        let direction = {
            x: 1,
            y: current.xyParity ? -1 : 1
        };
        let ribbon = [];
        do {
            current.ribbon = ribbons.length;
            ribbon.push(current);
            unusedCells.delete(current);
            const vWall = direction.x > 0 ? cells[current.y][current.x + 1]?.vWall !== false : current.vWall || current.x == 0, hWall = direction.y > 0 ? cells[current.y + 1]?.[current.x].hWall !== false : current.hWall || current.y == 0;
            // console.log(current, {vWall,hWall}, direction)
            if (vWall) {
                current.next = {
                    x: current.x,
                    y: current.y + direction.y
                };
                direction = {
                    x: -direction.x,
                    y: direction.y
                };
            } else if (hWall) {
                current.next = {
                    x: current.x + direction.x,
                    y: current.y
                };
                direction = {
                    x: direction.x,
                    y: -direction.y
                };
            } else current.next = {
                x: current.x + direction.x,
                y: current.y + direction.y
            };
            const next = cells[current.next.y][current.next.x];
            next.previous = {
                x: current.x,
                y: current.y
            };
            current = cells[current.next.y][current.next.x];
        // for (const row of cells) console.log(row.map(r => r.ribbon?.toString(36) ?? "-").join(""));
        }while (unusedCells.has(current));
        ribbons.push(ribbon);
    }
    return ribbons;
}



function $81d30da63ce23b28$var$svg(parent, inner) {
    parent.innerHTML += `
		<svg viewBox="0 0 264.58333 264.58333" xmlns="http://www.w3.org/2000/svg">
			<g>${inner}</g>
		</svg>`;
}
function $81d30da63ce23b28$export$2d76ff10f0dc389(parent) {
    $81d30da63ce23b28$var$svg(parent, `<path
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		d="m -26.458333,26.458333 h 52.916666 26.458333 c 136.359684,0 158.945264,35.700849 202.228884,79.309907 16.5352,16.65953 37.5233,37.19777 37.5233,37.19777 l 3.50664,161.91786 -140.84259,-0.49901 c 0,0 -29.57595,-27.59459 -37.36901,-36.35891 -5.85679,-6.58673 1.29392,0.32989 -4.71051,-5.39526 C 99.259419,249.28762 86.111621,238.45044 52.916666,238.125 c -33.194957,-0.32544 -79.374999,0 -79.374999,0 z"
	/>`);
}
function $81d30da63ce23b28$export$a35cddf151643781(parent) {
    $81d30da63ce23b28$var$svg(parent, `<rect
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		width="350"
		height="211.66666"
		x="-50"
		y="-238.125"
		transform="rotate(90)"
	/>`);
}
function $81d30da63ce23b28$export$c56a7d555ae912fb(parent) {
    $81d30da63ce23b28$var$svg(parent, `<path
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		d="M -26.458333,26.458333 H 238.125 V 291.04166 H 26.458333 V 238.125 h -52.916666 z"
	/>`);
}
function $81d30da63ce23b28$export$4a47b2bad41e26f1(parent) {
    $81d30da63ce23b28$var$svg(parent, `<rect
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		width="211.66666"
		height="411.25946"
		x="-292.92206"
		y="-205.62973"
		transform="rotate(-135)"
	/>`);
}
function $81d30da63ce23b28$export$427231bc3e9d3eec(parent) {
    $81d30da63ce23b28$var$svg(parent, `<rect
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		width="211.66666"
		height="411.25946"
		x="81.255341"
		y="-392.71851"
		transform="rotate(135)"
	/>`);
}


const $628bcc8876065384$var$container = document.getElementById("container");
class $628bcc8876065384$export$2e2bcd8739ae039 {
    constructor(w, h){
        this.w = w;
        this.h = h;
        this.el = (0, $13e636c115f5b023$export$863e749b3f21e4ce)("div.grid");
        this.cells = (0, $ccc8a8194b547ffa$export$2e2bcd8739ae039)(w, h);
        for(let y1 = 0; y1 < h * 2; ++y1)for(let x1 = 0; x1 < w * 2; ++x1){
            const cell = this.cells[y1][x1];
            cell.td = (0, $13e636c115f5b023$export$f9574b70e1d95d9d)(this.el, "div");
            cell.td.dataset.x = x1;
            cell.td.dataset.y = y1;
            cell.container = (0, $13e636c115f5b023$export$f9574b70e1d95d9d)(cell.td, "div.ribbon-images");
            cell.td.classList.add(cell.xParity ? "x-even" : "x-odd");
            cell.td.classList.add(cell.yParity ? "y-even" : "y-odd");
        }
        this.updateListeners = [];
        this.update(false);
    }
    toggleWall(x1, y1, direction) {
        if (x1 < 1 || y1 < 1 || x1 >= this.cells[0].length || y1 >= this.cells.length) return;
        const cell = this.cells[y1][x1], cellAbove = this.cells[y1 - 1][x1], cellLeft = this.cells[y1][x1 - 1];
        if (direction) {
            if (cell.hWall) {
                cell.hWall = cellLeft.hWall = false;
                cell.vWall = cellAbove.vWall = true;
            } else if (cell.vWall) cell.vWall = cellAbove.vWall = false;
            else cell.hWall = cellLeft.hWall = true;
        } else {
            if (cell.vWall) {
                cell.vWall = cellAbove.vWall = false;
                cell.hWall = cellLeft.hWall = true;
            } else if (cell.hWall) cell.hWall = cellLeft.hWall = false;
            else cell.vWall = cellAbove.vWall = true;
        }
        this.update(true);
    }
    *allCells() {
        for (const row of this.cells)yield* row;
    }
    onUpdate(callback) {
        this.updateListeners.push(callback);
    }
    update(...args) {
        this.ribbons = (0, $b45f222a6e87d68f$export$61a292a1761d5bd5)(this.cells).map((cells)=>new (0, $1d06730851e9bddb$export$2e2bcd8739ae039)(cells));
        this.render();
        for (const listener of this.updateListeners)listener(...args);
    }
    render() {
        for (const { container: container, td: td, vWall: vWall, hWall: hWall } of this.allCells()){
            (0, $13e636c115f5b023$export$2796c4ce44e61efa)(td, "v-wall", vWall);
            (0, $13e636c115f5b023$export$2796c4ce44e61efa)(td, "h-wall", hWall);
            container.innerHTML = "";
        }
        for (const { x: x1, y: y1, next: next1, previous: previous1, ribbon: ribbon, container: container } of this.allCells())$628bcc8876065384$var$tileImages(container, previous1, {
            x: x1,
            y: y1
        }, next1, this.cells, this.ribbons[ribbon]);
    }
}
function $628bcc8876065384$var$tf(el) {
    const tf = el.style.transform;
    if (!tf || tf == "none") return 0;
    if (tf.startsWith("rotate(")) return (tf.replace(/^rotate\((-?[\d.]+)deg\)$/, "$1") / 90 + 400) % 4;
    return tf;
}
// 1 2 3
// 4 * 6
// 7 8 9
function $628bcc8876065384$var$clock(x1, y1) {
    return y1 * 3 + x1 + 5;
}
function $628bcc8876065384$var$tileImages(container, previous1, { x: x1, y: y1 }, next1, allCells, ribbon) {
    let d11 = $628bcc8876065384$var$clock(previous1.x - x1, previous1.y - y1), d21 = $628bcc8876065384$var$clock(next1.x - x1, next1.y - y1);
    if (d11 > d21) [d11, d21] = [
        d21,
        d11
    ];
    // Draw the main image:
    // ribbon.addImage(child(container, "img.main", options(d1, d2)));
    ribbon.addImage($628bcc8876065384$var$createImage(container, `${d11}-${d21}`));
    // Add in any extra corners. We're only going to do the corners above us — the corners below us should get filled in by the tiles below.
    if (d11 == 1) {
        ribbon.addImage($628bcc8876065384$var$createImage(allCells[y1 - 1][x1].container, "d1y"));
        ribbon.addImage($628bcc8876065384$var$createImage(allCells[y1][x1 - 1].container, "d1x"));
    } else if (d11 == 3) {
        ribbon.addImage($628bcc8876065384$var$createImage(allCells[y1 - 1][x1].container, "d3y"));
        ribbon.addImage($628bcc8876065384$var$createImage(allCells[y1][x1 + 1].container, "d3x"));
    }
}
function $628bcc8876065384$var$createImage(parent, type) {
    const container = (0, $13e636c115f5b023$export$f9574b70e1d95d9d)(parent, `div.img-${type}`);
    switch(type.split(".")[0]){
        case "d1x":
        case "d3x":
        case "d1y":
        case "d3y":
            (0, $81d30da63ce23b28$export$427231bc3e9d3eec)(container);
            break;
        case "2-8":
        case "4-6":
            (0, $81d30da63ce23b28$export$a35cddf151643781)(container);
            break;
        case "1-9":
        case "3-7":
            (0, $81d30da63ce23b28$export$4a47b2bad41e26f1)(container);
            break;
        case "4-8":
        case "6-8":
        case "2-6":
        case "2-4":
            (0, $81d30da63ce23b28$export$c56a7d555ae912fb)(container);
            break;
        case "4-9":
        case "3-8":
        case "1-6":
        case "2-7":
        case "3-4":
        case "1-8":
        case "6-7":
        case "2-9":
            (0, $81d30da63ce23b28$export$2d76ff10f0dc389)(container);
            break;
        default:
            console.error({
                d1: d1,
                d2: d2,
                previous: previous,
                current: {
                    x: x,
                    y: y
                },
                next: next
            });
            throw new Error("Unexpected directions: " + d1 + ", " + d2);
    }
    return container;
}


class $d94e3b5082d91aa0$export$2e2bcd8739ae039 extends (0, $628bcc8876065384$export$2e2bcd8739ae039) {
    constructor(...args){
        super(...args);
        this.el.addEventListener("click", this.clickHandler(false));
        this.el.addEventListener("contextmenu", this.clickHandler(true));
    }
    clickHandler(direction) {
        return (e)=>{
            e.preventDefault();
            const td = (0, $13e636c115f5b023$export$157e4ea108f7048c)(e.target, (e)=>e.dataset.x);
            if (!td) {
                console.log("Unexpected element click", e.target);
                return;
            }
            // OK so: wall locations are centred around the 'off' corners, the ones without dots in, so we need to work out which we're nearest.
            const { x: x, y: y, xyParity: xyParity } = this.cells[td.dataset.y][td.dataset.x];
            // TODO: REMOVE THIS HACK THAT REPLACES THE CLICK ACTION WITH HIGHLIGHT
            // for (const r of this.ribbons) r.highlightBy(x, y); return;
            // if the user clicked a button, we don't care where on the button they clicked —
            // buttons are centred on the particular intersection they're in so just use that
            if (e.target.tagName === "BUTTON") {
                this.toggleWall(x, y, direction);
                return;
            }
            const rect = td.getBoundingClientRect();
            const mouseX = (event.clientX - rect.left) / rect.width;
            const mouseY = (event.clientY - rect.top) / rect.height;
            if (xyParity && mouseX > mouseY) this.toggleWall(x + 1, y, direction);
            if (xyParity && mouseX <= mouseY) this.toggleWall(x, y + 1, direction);
            if (!xyParity && mouseX <= 1 - mouseY) this.toggleWall(x, y, direction);
            if (!xyParity && mouseX > 1 - mouseY) this.toggleWall(x + 1, y + 1, direction);
        };
    }
}



class $4ce175274789813d$export$2e2bcd8739ae039 extends (0, $d94e3b5082d91aa0$export$2e2bcd8739ae039) {
    constructor(...args){
        super(...args);
        this.wallButtons = [];
        this.allWallButtons = [];
        for (const { x: x, y: y, xyParity: xyParity, td: td } of this.allCells()){
            if (xyParity || !x || !y) continue;
            if (!this.wallButtons[y]) this.wallButtons[y] = [];
            const b = (0, $13e636c115f5b023$export$f9574b70e1d95d9d)(td, "button.wall-button");
            this.wallButtons[y][x] = b;
            b.dataset.x = x;
            b.dataset.y = y;
            b.innerText = "Add wall";
            this.allWallButtons.push(b);
        }
        this.setActiveWallButton(2, 1, true);
        this.el.addEventListener("keydown", this.keyboardHandler());
    }
    setActiveWallButton(x, y, noFocus) {
        if (x == 12) x = 10;
        this.activeWallButton = this.wallButtons[y][x];
        for (const b of this.allWallButtons)b.classList.remove("active");
        this.activeWallButton.classList.add("active");
        if (!noFocus) this.activeWallButton.focus();
    }
    keyboardHandler() {
        return (e)=>{
            const x = parseInt(this.activeWallButton.dataset.x, 10), y = parseInt(this.activeWallButton.dataset.y, 10);
            switch(e.key){
                case "ArrowRight":
                    if (x < 10) this.setActiveWallButton(x + 2, y);
                    break;
                case "ArrowLeft":
                    if (x > 2) this.setActiveWallButton(x - 2, y);
                    break;
                case "ArrowUp":
                    if (y > 1) this.setActiveWallButton(x + 1 - 2 * (y & 1), y - 1);
                    break;
                case "ArrowDown":
                    if (y < 19) this.setActiveWallButton(x + 1 - 2 * (y & 1), y + 1);
                    break;
                // strictly we don't need to handle space since it fires as a click handler anyway
                // but i think it's way less confusing if we do it explicitly here
                case " ":
                case "Space":
                    this.toggleWall(x, y);
                    break;
                default:
                    console.log(e);
                    return;
            }
            e.preventDefault();
        };
    }
}


class $fbd6a8ac037d9cf6$export$2e2bcd8739ae039 extends (0, $4ce175274789813d$export$2e2bcd8739ae039) {
    constructor(...args){
        super(...args);
        this.undoStack = [
            this.undoEntry()
        ];
        this.undoPointer = 0; // position in stack of current game state
        this.onUpdate((fromInput)=>{
            if (!fromInput) return;
            // Worked example of how the undo numbers work:
            // Here we're adding to the undo stack. The undo pointer is currently 2,
            // but there are 5 entries in the undo stack because there's some redo buffer.
            // stack = [ 0, 1, currentGameState, 3, 4 ]
            // First, discard everything but the first 4 entries,
            this.undoStack.splice(++this.undoPointer);
            // After pushing the new entry,
            this.undoStack.push(this.undoEntry());
        // the stack will have length 5 and the pointer will be 4, which is correct.
        // stack = [ 0, 1, 2, currentGameState ]
        });
    }
    undoEntry() {
        return this.cells.map((row)=>row.map((cell)=>[
                    cell.vWall,
                    cell.hWall
                ]));
    }
    undo() {
        if (!this.undoPointer) return;
        // Suppose we now undo something.
        // The undo pointer is 3, and the stack has 4 entries:
        // stack = [ 0, 1, target, currentGameState ]
        // We want the pointer to be 2.
        // Entry 3 is not discarded, in case we want to redo later.
        this.apply(this.undoStack[--this.undoPointer]);
    // stack = [ 0, 1, currentGameState, 2 ]
    }
    redo() {
        if (this.undoPointer == this.undoStack.length - 1) return;
        // It is now later.
        // The undo pointer is 2, and the stack has 4 entries:
        // stack = [ 0, 1, currentGameState, 2 ]
        // We want to move the undo pointer to 3 and apply the result.
        this.apply(this.undoStack[++this.undoPointer]);
    // stack = [ 0, 1, 2, currentGameState ]
    }
    apply(entry) {
        for(let y = 0; y < this.cells.length; ++y)for(let x = 0; x < this.cells[y].length; ++x)[this.cells[y][x].vWall, this.cells[y][x].hWall] = entry[y][x];
        this.update(false);
    }
    removeAllWalls() {
        for (const cell of this.allCells())cell.vWall = cell.hWall = false;
        this.update(true);
    }
}


function $cfc351a74e8b0491$export$2e2bcd8739ae039() {
    return Object.fromEntries(location.search.substr(1).split("&").map((str)=>{
        const i = str.indexOf("=");
        if (i < 0) return [
            str,
            null
        ];
        return [
            str.substring(0, i),
            str.substring(i + 1)
        ].map(decodeURIComponent);
    }));
}
const $cfc351a74e8b0491$export$9d9f8d4298fb8caa = $cfc351a74e8b0491$export$2e2bcd8739ae039();


const $f659b2083d131d24$var$\u03A6 = (1 + Math.sqrt(5)) / 2;
function $f659b2083d131d24$var$colourBank(n = 10) {
    const count = [];
    for(let i = 0; i < n; ++i)count[i] = 0;
    return {
        use (colour) {
            if (!colour.startsWith("r")) return;
            ++count[parseInt(colour.substring(1), 10)];
        },
        next () {
            const nextColour = count.indexOf(Math.min(...count));
            ++count[nextColour];
            return `r${nextColour}`;
        }
    };
}
function $f659b2083d131d24$export$2e2bcd8739ae039() {
    let lastRibbons;
    return (ribbons, puzzleBeads)=>{
        const { use: use, next: next } = $f659b2083d131d24$var$colourBank();
        const uncolouredRibbons = new Set(ribbons);
        // colour any completed ribbons their bead colour
        for (const r of uncolouredRibbons){
            const { complete: complete, colour: colour } = r.isComplete(puzzleBeads);
            if (!complete) continue;
            r.setClass(`p${colour + 1}`);
            uncolouredRibbons.delete(r);
        }
        // find the most overlapping ribbons and carry forward their colours
        if (lastRibbons) for (const l of lastRibbons.filter((r)=>!r.isComplete(puzzleBeads).complete).sort((a, b)=>b.size - a.size)){
            const mostSimilar = l.mostSimilar(uncolouredRibbons);
            if (!mostSimilar) continue;
            const { colour: colour } = mostSimilar.isComplete(puzzleBeads);
            const [className] = l.classes;
            if (colour) mostSimilar.setClass(className, `i${colour + 1}`);
            else mostSimilar.setClass(className);
            use(className);
            uncolouredRibbons.delete(mostSimilar);
        }
        for (const ribbon of uncolouredRibbons){
            const { colour: colour } = ribbon.isComplete(puzzleBeads);
            if (colour) ribbon.setClass(next(), `i${colour + 1}`);
            else ribbon.setClass(next());
        }
        lastRibbons = ribbons;
    };
}


function $000c919b85545119$export$2e2bcd8739ae039(namespace, defaults) {
    function wrapKey(key) {
        return `${namespace}_${key}`;
    }
    const data = {
        clear () {
            for(const key in defaults)localStorage.removeItem(wrapKey(key));
        },
        export (except, transforms) {
            const j = {};
            for(const key in defaults)if (!except.includes(key)) j[key] = transforms[key] ? transforms[key](data[key]) : data[key];
            return btoa(JSON.stringify(j));
        },
        import (b64, transforms) {
            const j = JSON.parse(atob(b64));
            for(const key in j)data[key] = transforms[key] ? transforms[key](j[key]) : j[key];
        }
    };
    for(const key in defaults)Object.defineProperty(data, key, {
        get: ()=>JSON.parse(localStorage.getItem(wrapKey(key))) ?? defaults[key],
        set: (value)=>localStorage.setItem(wrapKey(key), JSON.stringify(value ?? null))
    });
    return data;
}


const $800cf654af4a580b$export$8a4b4288adcd729e = "ON";
const $800cf654af4a580b$export$173de64b5ad0d5b4 = "OFF";
const $800cf654af4a580b$export$52653a075d3f70dc = "SYS";
function $800cf654af4a580b$export$adadd170102d7a8a(mode = $800cf654af4a580b$export$52653a075d3f70dc) {
    return $800cf654af4a580b$var$init("(prefers-color-scheme: dark)", "dark-mode", mode);
}
function $800cf654af4a580b$export$5b8b5e316636fba1(mode = $800cf654af4a580b$export$52653a075d3f70dc) {
    return $800cf654af4a580b$var$init("(prefers-reduced-motion: reduce)", "reduced-motion", mode);
}
function $800cf654af4a580b$var$init(queryString, bodyClass, mode) {
    const query = window.matchMedia(queryString);
    const listeners = {
        enable: [],
        disable: [],
        change: []
    };
    const returnedObject = {
        active: mode == $800cf654af4a580b$export$8a4b4288adcd729e ? true : mode == $800cf654af4a580b$export$173de64b5ad0d5b4 ? false : query.matches,
        mode: mode,
        addEventListener (e, cb) {
            listeners[e].push(cb);
        },
        removeEventListener (e, cb) {
            listeners[e] = listeners[e].filter((x)=>x != cb);
        },
        setOn () {
            returnedObject.mode = $800cf654af4a580b$export$8a4b4288adcd729e;
            if (returnedObject.active) return;
            returnedObject.active = true;
            update();
        },
        setOff () {
            returnedObject.mode = $800cf654af4a580b$export$173de64b5ad0d5b4;
            if (!returnedObject.active) return;
            returnedObject.active = false;
            update();
        },
        setSystem () {
            returnedObject.mode = $800cf654af4a580b$export$52653a075d3f70dc;
            if (returnedObject.active == query.matches) return;
            returnedObject.active = query.matches;
            update();
        }
    };
    setBodyClass();
    query.addEventListener("change", (event)=>{
        if (returnedObject.mode != $800cf654af4a580b$export$52653a075d3f70dc) return;
        returnedObject.active = event.matches;
        update();
    });
    return returnedObject;
    function update() {
        setBodyClass();
        if (returnedObject.active) for (const cb of listeners.enable)cb();
        else for (const cb of listeners.disable)cb();
        for (const cb of listeners.change)cb(returnedObject.active);
    }
    function setBodyClass() {
        if (returnedObject.active) document.body.classList.add(bodyClass);
        else document.body.classList.remove(bodyClass);
    }
}


const $c10fc4dd470a6ad9$export$9279224462a04bc4 = "2024-06-09";
const $c10fc4dd470a6ad9$export$a53b857e6eeb1e18 = []; // ['2023-10-21'];
const $c10fc4dd470a6ad9$export$76a88f7de6507443 = "celtix";
const $c10fc4dd470a6ad9$export$ebe90cb607ad99e = {
    streak: 0,
    nextPuzzle: 0,
    bestStreak: 0,
    results: {},
    savedState: {
        puzzleId: -1
    },
    dark: (0, $800cf654af4a580b$export$52653a075d3f70dc),
    reducedMotion: (0, $800cf654af4a580b$export$52653a075d3f70dc),
    colourScheme: "default",
    bestSolutions: {}
};
const $c10fc4dd470a6ad9$export$5a48c1f5410d732 = [
    "savedState",
    "bestSolutions"
];
const $c10fc4dd470a6ad9$export$5a4b8f43f2b42577 = {
    results: (object)=>{
        const keys = Object.keys(object).map(parseFloat);
        const max = Math.max(...keys);
        const array = [];
        for(let i = 1; i <= max; ++i)array[i - 1] = object[i] ?? 0;
        return array.join("");
    }
};
const $c10fc4dd470a6ad9$export$39e3ce5a9fd9302c = {
    results: (string)=>{
        const val = {};
        for(let i = 0; i < string.length; ++i)val[i + 1] = parseInt(string[i]);
        return val;
    }
};



const $5574c6a912fdb784$var$storage = (0, $000c919b85545119$export$2e2bcd8739ae039)((0, $c10fc4dd470a6ad9$export$76a88f7de6507443), (0, $c10fc4dd470a6ad9$export$ebe90cb607ad99e));
if ((0, $cfc351a74e8b0491$export$9d9f8d4298fb8caa).data) {
    if (confirm("Would you like to import your Celtix data from your other device? This will overwrite any data you have stored on this device.")) $5574c6a912fdb784$var$storage.import((0, $cfc351a74e8b0491$export$9d9f8d4298fb8caa).data, (0, $c10fc4dd470a6ad9$export$39e3ce5a9fd9302c));
    location.search = "";
}
document.getElementById("export-data-button").addEventListener("click", ()=>{
    const url = `${location.origin}${location.pathname}?data=${$5574c6a912fdb784$var$storage.export((0, $c10fc4dd470a6ad9$export$5a48c1f5410d732), (0, $c10fc4dd470a6ad9$export$5a4b8f43f2b42577))}`;
    document.getElementById("export-data-link").setAttribute("href", url);
    document.getElementById("export-data-qr").innerHTML = "";
    try {
        new QRCode(document.getElementById("export-data-qr"), {
            text: url,
            width: 1024,
            height: 1024
        });
        document.getElementById("export-data-qr-worked").classList.remove("hidden");
    } catch (e) {
        console.log("Too much data for QR code");
        document.getElementById("export-data-qr-worked").classList.add("hidden");
    }
});
document.getElementById("confirm-delete-data").addEventListener("click", async ()=>{
    $5574c6a912fdb784$var$storage.clear();
    location.reload();
});
var $5574c6a912fdb784$export$2e2bcd8739ae039 = $5574c6a912fdb784$var$storage;




async function $63ab878aa0fcf0b5$export$2e2bcd8739ae039(fn) {
    const response = await fetch(fn);
    if (response.status > 200) throw new Error(`HTTP ${response.status} error`);
    return await response.json();
}


const $3f154a3b8c35f487$var$oneDay = 86400000;
const $3f154a3b8c35f487$var$epoch = $3f154a3b8c35f487$var$parseDate((0, $c10fc4dd470a6ad9$export$9279224462a04bc4));
const $3f154a3b8c35f487$export$8f34a02f264abc32 = $3f154a3b8c35f487$var$getTodaysPuzzleId();
const $3f154a3b8c35f487$export$d9ce9a4ea73a329 = (0, $cfc351a74e8b0491$export$9d9f8d4298fb8caa).p ?? $3f154a3b8c35f487$export$8f34a02f264abc32.toString();
const $3f154a3b8c35f487$export$2e3800c22813858b = $3f154a3b8c35f487$export$d9ce9a4ea73a329 == $3f154a3b8c35f487$export$8f34a02f264abc32;
const $3f154a3b8c35f487$export$8d3a4cfef4779d04 = 0;
const $3f154a3b8c35f487$export$fcf50324bc0d9c86 = 1;
const $3f154a3b8c35f487$export$fc332a617fd34192 = 2;
const $3f154a3b8c35f487$export$9ae3aad9817db743 = 3;
const $3f154a3b8c35f487$export$d71930f7f5807a72 = 4;
const $3f154a3b8c35f487$var$todayNext = document.getElementById("today-next"), $3f154a3b8c35f487$var$game = document.getElementById("game"), $3f154a3b8c35f487$var$nextPuzzleContainer = document.getElementById("next-puzzle-container");
if ($3f154a3b8c35f487$export$2e3800c22813858b) {
    document.getElementById("jump-to-today").classList.add("hidden");
    $3f154a3b8c35f487$var$todayNext.classList.add("hidden");
    $3f154a3b8c35f487$var$runTimer(document.getElementById("next-puzzle"));
} else $3f154a3b8c35f487$var$nextPuzzleContainer.classList.add("hidden");
function $3f154a3b8c35f487$var$updateStreakDom() {
    document.getElementById("current-streak").innerHTML = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).nextPuzzle >= $3f154a3b8c35f487$export$8f34a02f264abc32 ? (0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak : 0;
    document.getElementById("best-streak").innerHTML = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestStreak;
    document.getElementById("current-streak-2").innerHTML = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak;
    document.getElementById("best-streak-2").innerHTML = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestStreak;
    document.getElementById("completion-percent").innerHTML = Math.floor(Object.values((0, $5574c6a912fdb784$export$2e2bcd8739ae039).results).reduce((a, n)=>a + (n == $3f154a3b8c35f487$export$fc332a617fd34192), 0) * 100 / $3f154a3b8c35f487$export$8f34a02f264abc32) + "%";
}
$3f154a3b8c35f487$var$updateStreakDom();
async function $3f154a3b8c35f487$export$2e2bcd8739ae039() {
    if (!/^\d+\+?$/.test($3f154a3b8c35f487$export$d9ce9a4ea73a329)) throw new Error("Invalid puzzle code");
    if (/^\d+$/.test($3f154a3b8c35f487$export$d9ce9a4ea73a329) && parseInt($3f154a3b8c35f487$export$d9ce9a4ea73a329, 10) > $3f154a3b8c35f487$export$8f34a02f264abc32) throw new Error("Puzzle not available yet");
    const strictId = $3f154a3b8c35f487$export$d9ce9a4ea73a329.replace(/\+/, "");
    document.getElementById("puzzle-id").appendChild(document.createTextNode("#" + strictId));
    try {
        const json = await (0, $63ab878aa0fcf0b5$export$2e2bcd8739ae039)(`puzzles/${strictId}.json`);
        document.getElementById("close-instructions").innerHTML = $3f154a3b8c35f487$export$2e3800c22813858b ? "Start" : `Start puzzle #${$3f154a3b8c35f487$export$d9ce9a4ea73a329}`;
        document.getElementById("close-instructions").disabled = false;
        return json;
    } catch (e) {
        console.error(e);
        alert("Unable to load puzzle data");
    }
}
const $3f154a3b8c35f487$var$textResults = {
    [$3f154a3b8c35f487$export$fcf50324bc0d9c86]: "\uD83D\uDC40",
    [$3f154a3b8c35f487$export$fc332a617fd34192]: "\uD83C\uDF89",
    undefined: "\u2728",
    [$3f154a3b8c35f487$export$8d3a4cfef4779d04]: "\u2728",
    [$3f154a3b8c35f487$export$9ae3aad9817db743]: "\uD83D\uDD2E",
    [$3f154a3b8c35f487$export$d71930f7f5807a72]: "\uD83D\uDC80"
};
function $3f154a3b8c35f487$var$optionText(i) {
    return $3f154a3b8c35f487$var$textResults[(0, $5574c6a912fdb784$export$2e2bcd8739ae039).results[i]] + " " + (i == $3f154a3b8c35f487$export$8f34a02f264abc32 ? "Today\u2019s Puzzle" : `Puzzle ${i}`);
}
for(let i = $3f154a3b8c35f487$export$8f34a02f264abc32; i; --i){
    const el = document.createElement("option");
    el.value = i;
    el.appendChild(document.createTextNode($3f154a3b8c35f487$var$optionText(i)));
    $3f154a3b8c35f487$var$game.appendChild(el);
}
$3f154a3b8c35f487$var$game.value = $3f154a3b8c35f487$export$d9ce9a4ea73a329;
$3f154a3b8c35f487$var$game.addEventListener("change", (e)=>{
    const i = e.target.value;
    if (i) window.location.search = `?p=${i}`;
});
function $3f154a3b8c35f487$var$setResult(result) {
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).results = {
        ...(0, $5574c6a912fdb784$export$2e2bcd8739ae039).results,
        [$3f154a3b8c35f487$export$d9ce9a4ea73a329]: result
    };
    if ($3f154a3b8c35f487$export$2e3800c22813858b) $3f154a3b8c35f487$var$updateStreak(result);
    const option = document.querySelector(`option[value="${$3f154a3b8c35f487$export$d9ce9a4ea73a329}"]`);
    if (option) option.innerHTML = $3f154a3b8c35f487$var$optionText($3f154a3b8c35f487$export$d9ce9a4ea73a329);
    $3f154a3b8c35f487$var$updateStreakDom();
}
function $3f154a3b8c35f487$var$updateStreak(result) {
    switch(result){
        case $3f154a3b8c35f487$export$fc332a617fd34192:
            const intPId = parseInt($3f154a3b8c35f487$export$d9ce9a4ea73a329, 10);
            if ((0, $5574c6a912fdb784$export$2e2bcd8739ae039).nextPuzzle == intPId) (0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak += 1;
            else if (intPId > (0, $5574c6a912fdb784$export$2e2bcd8739ae039).nextPuzzle) (0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak = 1;
            break;
        case $3f154a3b8c35f487$export$9ae3aad9817db743:
        case $3f154a3b8c35f487$export$d71930f7f5807a72:
            (0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak = 0;
            break;
        default:
            return; // no streak things happen unless the game ended
    }
    if ((0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak > (0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestStreak) (0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestStreak = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).streak;
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).nextPuzzle = $3f154a3b8c35f487$export$8f34a02f264abc32 + 1;
}
function $3f154a3b8c35f487$export$aaa2d21dd8862419() {
    if (!(0, $5574c6a912fdb784$export$2e2bcd8739ae039).results[$3f154a3b8c35f487$export$d9ce9a4ea73a329]) $3f154a3b8c35f487$var$setResult($3f154a3b8c35f487$export$fcf50324bc0d9c86);
}
function $3f154a3b8c35f487$export$e73fc3c380b3a82c() {
    if ((0, $5574c6a912fdb784$export$2e2bcd8739ae039).results[$3f154a3b8c35f487$export$d9ce9a4ea73a329] !== $3f154a3b8c35f487$export$fc332a617fd34192) $3f154a3b8c35f487$var$setResult($3f154a3b8c35f487$export$9ae3aad9817db743);
}
function $3f154a3b8c35f487$export$9dc2ba43fcebbd21() {
    if ((0, $5574c6a912fdb784$export$2e2bcd8739ae039).results[$3f154a3b8c35f487$export$d9ce9a4ea73a329] !== $3f154a3b8c35f487$export$9ae3aad9817db743) $3f154a3b8c35f487$var$setResult($3f154a3b8c35f487$export$fc332a617fd34192);
}
function $3f154a3b8c35f487$var$runTimer(el) {
    const h = setInterval(update, 1000);
    update();
    function update() {
        const ms = ($3f154a3b8c35f487$var$epoch + $3f154a3b8c35f487$export$8f34a02f264abc32 * $3f154a3b8c35f487$var$oneDay - Date.now()) % $3f154a3b8c35f487$var$oneDay, s = ~~(ms / 1000);
        if (s < 0) {
            $3f154a3b8c35f487$var$todayNext.classList.remove("hidden");
            $3f154a3b8c35f487$var$nextPuzzleContainer.classList.add("hidden");
            clearInterval(h);
        } else el.innerHTML = `${$3f154a3b8c35f487$var$pad(~~(s / 3600))}:${$3f154a3b8c35f487$var$pad(~~(s / 60) % 60)}:${$3f154a3b8c35f487$var$pad(s % 60)}`;
    }
}
function $3f154a3b8c35f487$var$pad(n) {
    return n > 9 ? `${n}` : `0${n}`;
}
// returns ms from 1970-01-01T00:00:00.000Z
function $3f154a3b8c35f487$var$parseDate(dateString) {
    const parts = dateString.split("-").map((x)=>parseInt(x, 10));
    --parts[1];
    return Date.UTC(...parts);
}
function $3f154a3b8c35f487$var$getTodaysPuzzleId() {
    // This is the basic time you'd expect if there were no skip dates
    let id = Math.floor((Date.now() - $3f154a3b8c35f487$var$epoch) / $3f154a3b8c35f487$var$oneDay + 1);
    // For every skip date that's today or earlier, we effectively go back one
    return id - (0, $c10fc4dd470a6ad9$export$a53b857e6eeb1e18).filter($3f154a3b8c35f487$var$dateIsTodayOrEarlier).length;
}
function $3f154a3b8c35f487$var$dateIsTodayOrEarlier(dateString) {
    return $3f154a3b8c35f487$var$parseDate(dateString) < Date.now();
}






const $2585479f1d625ae2$export$808aaf1b460dc9af = (0, $800cf654af4a580b$export$adadd170102d7a8a)((0, $5574c6a912fdb784$export$2e2bcd8739ae039).dark ?? (0, $800cf654af4a580b$export$52653a075d3f70dc));
const $2585479f1d625ae2$export$228b524d61e8880a = (0, $800cf654af4a580b$export$5b8b5e316636fba1)((0, $5574c6a912fdb784$export$2e2bcd8739ae039).reducedMotion ?? (0, $800cf654af4a580b$export$52653a075d3f70dc));
const $2585479f1d625ae2$var$darkOn = document.getElementById("dark-on"), $2585479f1d625ae2$var$darkOff = document.getElementById("dark-off"), $2585479f1d625ae2$var$darkSystem = document.getElementById("dark-system"), $2585479f1d625ae2$var$reducedMotionOn = document.getElementById("reduced-motion-on"), $2585479f1d625ae2$var$reducedMotionOff = document.getElementById("reduced-motion-off"), $2585479f1d625ae2$var$reducedMotionSystem = document.getElementById("reduced-motion-system");
switch((0, $5574c6a912fdb784$export$2e2bcd8739ae039).dark){
    case 0, $800cf654af4a580b$export$8a4b4288adcd729e:
        $2585479f1d625ae2$var$darkOn.checked = true;
        break;
    case 0, $800cf654af4a580b$export$173de64b5ad0d5b4:
        $2585479f1d625ae2$var$darkOff.checked = true;
        break;
    default:
        $2585479f1d625ae2$var$darkSystem.checked = true;
        break;
}
switch((0, $5574c6a912fdb784$export$2e2bcd8739ae039).reducedMotion){
    case 0, $800cf654af4a580b$export$8a4b4288adcd729e:
        $2585479f1d625ae2$var$reducedMotionOn.checked = true;
        break;
    case 0, $800cf654af4a580b$export$173de64b5ad0d5b4:
        $2585479f1d625ae2$var$reducedMotionOff.checked = true;
        break;
    default:
        $2585479f1d625ae2$var$reducedMotionSystem.checked = true;
        break;
}
$2585479f1d625ae2$var$darkOn.addEventListener("click", (e)=>{
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).dark = (0, $800cf654af4a580b$export$8a4b4288adcd729e);
    $2585479f1d625ae2$export$808aaf1b460dc9af.setOn();
});
$2585479f1d625ae2$var$darkOff.addEventListener("click", (e)=>{
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).dark = (0, $800cf654af4a580b$export$173de64b5ad0d5b4);
    $2585479f1d625ae2$export$808aaf1b460dc9af.setOff();
});
$2585479f1d625ae2$var$darkSystem.addEventListener("click", (e)=>{
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).dark = (0, $800cf654af4a580b$export$52653a075d3f70dc);
    $2585479f1d625ae2$export$808aaf1b460dc9af.setSystem();
});
$2585479f1d625ae2$var$reducedMotionOn.addEventListener("click", (e)=>{
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).reducedMotion = (0, $800cf654af4a580b$export$8a4b4288adcd729e);
    $2585479f1d625ae2$export$228b524d61e8880a.setOn();
});
$2585479f1d625ae2$var$reducedMotionOff.addEventListener("click", (e)=>{
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).reducedMotion = (0, $800cf654af4a580b$export$173de64b5ad0d5b4);
    $2585479f1d625ae2$export$228b524d61e8880a.setOff();
});
$2585479f1d625ae2$var$reducedMotionSystem.addEventListener("click", (e)=>{
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).reducedMotion = (0, $800cf654af4a580b$export$52653a075d3f70dc);
    $2585479f1d625ae2$export$228b524d61e8880a.setSystem();
});


document.getElementById("main-menu-button").addEventListener("click", ()=>document.getElementById("close-instructions").innerHTML = "Close");
function $9e03e5234ba4ec7e$export$a7f6cffb6b8ba11c(id) {
    document.getElementById(id).showModal();
}
function $9e03e5234ba4ec7e$export$3f6fecd573f3fa48(id) {
    document.getElementById(id).close();
}
for (const el of document.querySelectorAll("button[data-modal]"))el.addEventListener("click", (e)=>$9e03e5234ba4ec7e$export$a7f6cffb6b8ba11c(el.dataset.modal));
let $9e03e5234ba4ec7e$var$text, $9e03e5234ba4ec7e$var$url;
document.getElementById("submit").addEventListener("click", (e)=>{
    const walls = document.getElementById("best").innerText;
    $9e03e5234ba4ec7e$var$text = `I completed #Celtix ${0, $3f154a3b8c35f487$export$d9ce9a4ea73a329} using ${walls} walls.`;
    $9e03e5234ba4ec7e$var$url = `http://www.andrewt.net/puzzles/celtix?p=${0, $3f154a3b8c35f487$export$d9ce9a4ea73a329}`;
    document.getElementById("share-preview").innerText = $9e03e5234ba4ec7e$var$text;
});
const $9e03e5234ba4ec7e$var$shareNative = document.getElementById("share-native");
(0, $13e636c115f5b023$export$2796c4ce44e61efa)($9e03e5234ba4ec7e$var$shareNative, "hidden", !navigator.share);
$9e03e5234ba4ec7e$var$shareNative.addEventListener("click", (e)=>navigator.share({
        title: "Celtix",
        text: $9e03e5234ba4ec7e$var$text,
        url: $9e03e5234ba4ec7e$var$url
    }));
document.getElementById("share-clipboard").addEventListener("click", ()=>navigator.clipboard.writeText(`${$9e03e5234ba4ec7e$var$text}\n\n${$9e03e5234ba4ec7e$var$url}`));




function $7184b002f042a2ed$export$ea32cbdd559da174(grid) {
    if ((0, $5574c6a912fdb784$export$2e2bcd8739ae039).savedState.puzzleId == (0, $3f154a3b8c35f487$export$d9ce9a4ea73a329)) {
        $7184b002f042a2ed$var$applySave((0, $5574c6a912fdb784$export$2e2bcd8739ae039).savedState.gridState, grid);
        $7184b002f042a2ed$var$applyUndoStack((0, $5574c6a912fdb784$export$2e2bcd8739ae039).savedState.undoStack, grid);
        return;
    }
    if ((0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestSolutions[0, $3f154a3b8c35f487$export$d9ce9a4ea73a329]) $7184b002f042a2ed$var$applySave((0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestSolutions[0, $3f154a3b8c35f487$export$d9ce9a4ea73a329].gridState, grid);
}
function $7184b002f042a2ed$export$fb931cd598921492(grid, wallCount, complete) {
    if (0, $3f154a3b8c35f487$export$2e3800c22813858b) (0, $5574c6a912fdb784$export$2e2bcd8739ae039).savedState = {
        puzzleId: $3f154a3b8c35f487$export$d9ce9a4ea73a329,
        gridState: $7184b002f042a2ed$var$encodeGridState(grid),
        undoStack: {
            stack: grid.undoStack.map($7184b002f042a2ed$var$encodeUndoStackEntry),
            pointer: grid.undoPointer
        }
    };
    const current = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestSolutions[0, $3f154a3b8c35f487$export$d9ce9a4ea73a329];
    if (complete && (!current || wallCount <= current.wallCount)) (0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestSolutions = {
        ...(0, $5574c6a912fdb784$export$2e2bcd8739ae039).bestSolutions,
        wallCount: undefined,
        gridState: undefined,
        [(0, $3f154a3b8c35f487$export$d9ce9a4ea73a329)]: {
            wallCount: wallCount,
            gridState: $7184b002f042a2ed$var$encodeGridState(grid)
        }
    };
}
function $7184b002f042a2ed$var$encodeGridState(grid) {
    let encoding = "1";
    for (const row of grid.cells.slice(1))for (const cell of row.slice(1)){
        if (cell.xyParity) continue;
        if (cell.vWall) encoding += "v";
        else if (cell.hWall) encoding += "h";
        else encoding += "-";
    }
    return encoding;
}
function $7184b002f042a2ed$var$encodeUndoStackEntry(entry) {
    let encoding = "1";
    for(let y = 1; y < entry.length; ++y)for(let x = 1 + (y & 1); x < entry[y].length; x += 2){
        const [vWall, hWall] = entry[y][x];
        if (vWall) encoding += "v";
        else if (hWall) encoding += "h";
        else encoding += "-";
    }
    return encoding;
}
function $7184b002f042a2ed$var$applySave(state1, grid) {
    const values = [
        ...state1
    ];
    switch(values.shift()){
        case "1":
            for (const row of grid.cells.slice(1))for (const cell of row.slice(1)){
                if (cell.xyParity) continue;
                switch(values.shift()){
                    case "v":
                        cell.vWall = grid.cells[cell.y - 1][cell.x].vWall = true;
                        break;
                    case "h":
                        cell.hWall = grid.cells[cell.y][cell.x - 1].hWall = true;
                        break;
                    case "-":
                        break;
                    default:
                        console.warn("unexpected save state token in " + state1);
                }
            }
            break;
        default:
            console.warn("unexpected save state format in " + state1);
            return;
    }
    grid.update(false);
}
function $7184b002f042a2ed$var$applyUndoStack({ stack: stack, pointer: pointer }, grid) {
    grid.undoPointer = pointer;
    grid.undoStack = stack.map((entry)=>{
        const values = [
            ...entry
        ];
        switch(values.shift()){
            case "1":
                const e = grid.cells.map((row)=>row.map((cell)=>[
                            false,
                            false
                        ]));
                for (const row of grid.cells.slice(1))for (const cell of row.slice(1)){
                    if (cell.xyParity) continue;
                    switch(values.shift()){
                        case "v":
                            e[cell.y][cell.x][0] = e[cell.y - 1][cell.x][0] = true;
                            break;
                        case "h":
                            e[cell.y][cell.x][1] = e[cell.y][cell.x - 1][1] = true;
                            break;
                        case "-":
                            break;
                        default:
                            console.warn("unexpected save state token in " + state);
                    }
                }
                return e;
            default:
                throw new Error("Unexpected undo format in " + entry);
        }
    });
}






const $7a3f5a4bbb8ba202$var$preview = document.getElementById("colour-scheme-preview");
const $7a3f5a4bbb8ba202$var$grid = new (0, $628bcc8876065384$export$2e2bcd8739ae039)(4, 3);
$7a3f5a4bbb8ba202$var$grid.toggleWall(4, 3, false);
$7a3f5a4bbb8ba202$var$grid.toggleWall(3, 2, false);
$7a3f5a4bbb8ba202$var$grid.toggleWall(3, 4, false);
$7a3f5a4bbb8ba202$var$grid.toggleWall(2, 3, true);
$7a3f5a4bbb8ba202$var$grid.toggleWall(5, 4, true);
const $7a3f5a4bbb8ba202$var$colourRibbons = (0, $f659b2083d131d24$export$2e2bcd8739ae039)();
const $7a3f5a4bbb8ba202$var$markers = [
    {
        x: 3,
        y: 0,
        colour: 0
    },
    {
        x: 7,
        y: 5,
        colour: 0
    },
    {
        x: 2,
        y: 4,
        colour: 1
    },
    {
        x: 4,
        y: 3,
        colour: 1
    }
];
$7a3f5a4bbb8ba202$var$preview.appendChild($7a3f5a4bbb8ba202$var$grid.el);
$7a3f5a4bbb8ba202$var$grid.update();
$7a3f5a4bbb8ba202$var$colourRibbons($7a3f5a4bbb8ba202$var$grid.ribbons, $7a3f5a4bbb8ba202$var$markers);
for (const b of $7a3f5a4bbb8ba202$var$markers)b.el = (0, $13e636c115f5b023$export$f9574b70e1d95d9d)($7a3f5a4bbb8ba202$var$grid.cells[b.y][b.x].td, `div.bead.p${b.colour + 1}`);
const $7a3f5a4bbb8ba202$var$select = document.getElementById("colour-scheme");
$7a3f5a4bbb8ba202$var$select.value = (0, $5574c6a912fdb784$export$2e2bcd8739ae039).colourScheme;
document.body.classList.add($7a3f5a4bbb8ba202$var$select.value);
$7a3f5a4bbb8ba202$var$select.addEventListener("change", (e)=>{
    for (const { value: value } of $7a3f5a4bbb8ba202$var$select.querySelectorAll("option"))document.body.classList.remove(value);
    document.body.classList.add($7a3f5a4bbb8ba202$var$select.value);
    (0, $5574c6a912fdb784$export$2e2bcd8739ae039).colourScheme = $7a3f5a4bbb8ba202$var$select.value;
});


const $22f060edfb2d5fee$var$main = document.getElementById("main");
const $22f060edfb2d5fee$var$safari = !!navigator.vendor?.match(/apple/i);
function $22f060edfb2d5fee$var$fixSize() {
    let ratio = devicePixelRatio;
    if ($22f060edfb2d5fee$var$safari) ratio /= 2; // safari won't render properly unless everything is neatly lined up
    const w = window.innerWidth * ratio, h = window.innerHeight * ratio, tileSize = Math.floor(Math.min(w / 12, h / 24)) / ratio;
    $22f060edfb2d5fee$var$main.style = `
		width: ${tileSize * 12}px;
		height: ${tileSize * 24}px;
		left: ${Math.floor(w / 2 - tileSize * 6 * ratio) / ratio}px;
		top: ${Math.floor(h / 2 - tileSize * 12 * ratio) / ratio}px;
		font-size: ${tileSize * 0.5}px;
	`;
    const preview = document.querySelector("#colour-scheme-preview");
    const previewTileSize = Math.floor(tileSize * 2.6) / ratio;
    preview.style = `
		width: ${previewTileSize * 8}px;
		height: ${previewTileSize * 6}px;
		font-size: ${previewTileSize * 0.5}px;
	`;
}
$22f060edfb2d5fee$var$fixSize();
if ($22f060edfb2d5fee$var$safari) setTimeout($22f060edfb2d5fee$var$fixSize);
window.addEventListener("resize", $22f060edfb2d5fee$var$fixSize);


if (!(0, $cfc351a74e8b0491$export$9d9f8d4298fb8caa).data) (0, $3f154a3b8c35f487$export$2e2bcd8739ae039)().then((puzzle)=>{
    if (!puzzle) return;
    const { markers: markers, exampleSolution: exampleSolution } = puzzle;
    const w = exampleSolution[0].length / 2, h = exampleSolution.length / 2;
    const grid = new (0, $fbd6a8ac037d9cf6$export$2e2bcd8739ae039)(w, h);
    for (const b of markers)b.el = (0, $13e636c115f5b023$export$f9574b70e1d95d9d)(grid.cells[b.y][b.x].td, `div.bead.p${b.colour + 1}`);
    container.appendChild(grid.el);
    const colourRibbons = (0, $f659b2083d131d24$export$2e2bcd8739ae039)();
    (0, $7184b002f042a2ed$export$ea32cbdd559da174)(grid);
    (0, $3f154a3b8c35f487$export$aaa2d21dd8862419)();
    let bestWalls = null;
    grid.onUpdate(()=>{
        // work out which ribbon each bead is on
        for (const bead of markers){
            bead.currentRibbon = grid.ribbons.findIndex((r)=>r.includesTile(bead.x, bead.y));
            if (bead.currentRibbon < 0) throw new Error("unexpected ribbon");
        }
        const ribbonsPerColour = {};
        for (const { colour: colour, currentRibbon: currentRibbon } of markers){
            if (!ribbonsPerColour[colour]) ribbonsPerColour[colour] = new Set();
            ribbonsPerColour[colour].add(grid.ribbons[currentRibbon]);
        }
        colourRibbons(grid.ribbons, markers);
        let wallCount = 0;
        for (const { vWall: vWall, hWall: hWall } of grid.allCells()){
            if (vWall) wallCount += 0.5;
            if (hWall) wallCount += 0.5;
        }
        document.getElementById("wall-count").innerText = wallCount;
        const complete = grid.ribbons.every((r)=>r.isComplete(markers).complete);
        if (complete && (!bestWalls || bestWalls > wallCount)) bestWalls = wallCount;
        const completeBest = complete && bestWalls == wallCount;
        document.getElementById("best").innerText = bestWalls;
        document.getElementById("knot-count").innerText = grid.ribbons.length;
        const submit = document.getElementById("submit");
        (0, $13e636c115f5b023$export$2796c4ce44e61efa)(submit, "hidden", !complete && !bestWalls);
        (0, $13e636c115f5b023$export$2796c4ce44e61efa)(submit, "submit-this", completeBest);
        (0, $13e636c115f5b023$export$2796c4ce44e61efa)(submit, "submit-best", bestWalls && !completeBest);
        (0, $7184b002f042a2ed$export$fb931cd598921492)(grid, wallCount, complete);
        if (complete) (0, $3f154a3b8c35f487$export$9dc2ba43fcebbd21)();
    });
    grid.update(false);
    document.getElementById("reset").addEventListener("click", ()=>grid.removeAllWalls());
    document.getElementById("undo").addEventListener("click", ()=>grid.undo());
    document.getElementById("redo").addEventListener("click", ()=>grid.redo());
}).catch(()=>alert("Unable to load puzzle"));
(0, $9e03e5234ba4ec7e$export$a7f6cffb6b8ba11c)("instructions");


//# sourceMappingURL=index.2e35488d.js.map
